import React from "react";
import ReactDOM from "react-dom/client";
import LaunchSafelyPage from "./newtool/index";
import ClientPortalApp from "./newtool/client/ClientPortal";

function AppRouter() {
  if (typeof window !== "undefined") {
    const path = window.location.pathname;
    if (path.startsWith("/client")) {
      return <ClientPortalApp />;
    }
  }
  return <LaunchSafelyPage />;
}

const root = document.getElementById("root")!;
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
